document.addEventListener("DOMContentLoaded", function () {
  // Get the full URL
  var urlParams = new URLSearchParams(window.location.search);
  const productData = {};

  let sizeSelected = null;
  let colorSelected = null;
  let idType = null;

  $(".engrave-cards-container").click(function () {
    if ($(this).hasClass("selected-engrave-cards-container")) {
      return;
    }
    $(".pdpLoader").show();
    $(".engrave-cards-container").removeClass(
      "selected-engrave-cards-container"
    );
    $(this).addClass("selected-engrave-cards-container");
    var data = this.getAttribute("data-name");
    idType = data;
    var url = $(".call-sm").val();
    var urlEngrave = $(".call-engrave").val();
    var cardType = $(this).data("name");
    var urlToUse = cardType === "QR" ? url : urlEngrave;

    $.ajax({
      url: urlToUse,
      method: "GET",
      success: function (response) {
        console.log("Response:", response);
      },
      error: function (xhr, status, error) {
        console.log("AJAX error:", error);
      },
    });

    // Check if all selected to handle desktop scroll
    if (checkIfAllSelected()) {
      handleDesktopScroll();
    }
  });

  const upButton = document.querySelector(".up-button");
  const downButton = document.querySelector(".down-button");
  const imagesWrapper = document.querySelector(".images-wrapper");
  const productImages = imagesWrapper.querySelectorAll(".product-colors-image");
  let imageHeight = 88 + 5 * 2; // Image height (88px) + margin (8px * 2)

  const EngraveID = document.querySelector(".EngraveID-Container");
  const compareBenifits = document.querySelector(".compareBenifits");

  const visibleImagesCount = 5;
  let currentPosition = 0;
  const button = document.getElementById("customizeid");

  const sizeContainers = document.querySelectorAll(
    ".customize-size-container-variation"
  );
  const colorContainers = document.querySelectorAll(
    ".customize-color-container"
  );

  // Calculate the max scroll position based on the number of images
  const maxScroll = -(
    (productImages.length - visibleImagesCount) *
    imageHeight
  );

  // Function to check if all options are selected
  function checkIfAllSelected() {
    //eslint-disable-line

    if (sizeContainers.length == 0 && colorContainers.length == 0) {
      return true;
    }

    if (sizeContainers.length != 0 && colorContainers.length != 0) {
      return sizeSelected && colorSelected;
    } else {
      if (sizeContainers.length != 0 && sizeSelected != null) {
        return true;
      } else {
        if (colorContainers.length != 0 && colorSelected != null) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  // Scroll functionality for product images
  upButton.addEventListener("click", function () {
    if (currentPosition < 0) {
      currentPosition += imageHeight;
      imagesWrapper.style.transform = "translateY(" + currentPosition + "px)";
    }
  });

  downButton.addEventListener("click", function () {
    if (currentPosition > maxScroll) {
      currentPosition -= imageHeight;
      imagesWrapper.style.transform = "translateY(" + currentPosition + "px)";
    }
  });

  // Handle size selection
  sizeContainers.forEach(function (sizeContainer) {
    sizeContainer.addEventListener("click", function () {
      $("#sizeHeader").html("Size: ");
      sizeContainers.forEach(function (container) {
        return container.classList.remove("customize-size-container-active");
      });
      this.classList.add("customize-size-container-active");
      sizeSelected = this.getAttribute("data-size");
      document.querySelectorAll(".customize-size").forEach(function (element) {
        element.innerHTML = sizeSelected;
      });
      productSize = sizeSelected;
      if (checkIfAllSelected()) {
        // handleDesktopScroll();
      }
      $("#sizeHeader").removeClass("errorState");
      $(".customizeid-sizechart .customize-size-container").each(function () {
        $(this).removeClass("size-error-state");
      });
    });
  });

  const selectedSizeContainer = document.querySelector(
    ".customize-size-container-variation.selected"
  );
  if (selectedSizeContainer) {
    selectedSizeContainer.classList.add("customize-size-container-active"); // Ensure it's visually active
    sizeSelected = selectedSizeContainer.getAttribute("data-size");
    document.querySelectorAll(".customize-size").forEach(function (element) {
      element.innerHTML = sizeSelected;
    });
    productSize = sizeSelected;
    $("#sizeHeader").html("Size: ");
  }

  // $(".customize-color-container").click(function() {
  //     $(".customize-color-container").removeClass("customize-color-active");
  //     $(this).addClass("customize-color-active");
  // });

  // $("#customizeEngraveid").click(function () {
  //   if ($("#EngraveCheckboxPDP").prop("checked")) {
  //     $(".custom-checkbox-container .checkmark").css("border-color", "");
  //     $(".declaration .text").css("color", "");
  //   } else {
  //     $(".custom-checkbox-container .checkmark").css("border-color", "#e63946");
  //     $(".declaration .text").css("color", "#e63946");
  //   }
  // });

  $("#EngraveCheckbox").on("change", function () {
    if ($(this).prop("checked")) {
      // Reset styles if the checkbox is checked
      $(".custom-checkbox-container .checkmark").css({
        "border-color": "#051424",
      });
      $(".declaration .text").css("color", "#051424");
    } else {
      $("#engravingline3").val("");
      $("#engravingline4").val("");
      $("#pengravingline3").text("");
      $("#pengravingline4").text("");
    }
  });

  function handleColorSelection(colorContainer) {
    // Check if there is only one color and prevent unselecting
    if (colorContainers.length === 1) {
      return; // Exit without changing anything
    }
    if (colorContainer.classList.contains("selected")) {
      // If already selected, reset
      colorSelected = null;
      $("#colorHeader").html("Select Your Color: ");
      colorContainer.classList.remove("customize-color-active");

      document.querySelectorAll(".customize-color").forEach(function (element) {
        element.innerHTML = "";
      });
    } else {
      // If not selected, update selection
      $("#colorHeader").html("Color: ");

      // Remove active class from all
      colorContainers.forEach(function (container) {
        container.classList.remove("customize-color-active");
      });

      // Add active class to the clicked one
      colorContainer.classList.add("customize-color-active");

      colorSelected = colorContainer.getAttribute("data-attr-value");
      var colorName = colorSelected; // Just a more readable name

      document.querySelectorAll(".customize-color").forEach(function (element) {
        element.innerHTML = colorName;
      });

      productColor = colorName;
    }
  }

  // Add event listeners for clicks
  colorContainers.forEach(function (colorContainer) {
    colorContainer.addEventListener("click", function () {
      handleColorSelection(colorContainer);
      $("#colorHeader").removeClass("errorState");
      $(".customize-color-container").each(function () {
        $(this).removeClass("color-error-state");
      });
    });
  });

  const selectedColorContainer = document.querySelector(
    ".customize-color-container.selected"
  );
  if (selectedColorContainer) {
    selectedColorContainer.classList.add("customize-color-active"); // Ensure it's visually active
    colorSelected = selectedColorContainer.getAttribute("data-attr-value");
    productColor = colorSelected;

    // Update UI with the selected color name
    document.querySelectorAll(".customize-color").forEach(function (element) {
      element.innerHTML = colorSelected;
    });

    $("#colorHeader").html("Color: ");
    var pid = $(".product-id")[0].textContent;
    var dataUrl = $("#selectedVariationURL").attr("data-url");
    var urlParams = new URLSearchParams(window.location.search);
    var editPid = urlParams.get("editPid");
    if (!editPid) {
      $.ajax({
        url: dataUrl,
        method: "POST",
        data: { selectedVariant: pid },
        success: function (response) {
          if (response.inCart) {
            $("#customizeid , #customizeidQr")
              .text("Already In Your Cart")
              .css({ opacity: "0.5", "pointer-events": "none" });
          } else {
            $("#customizeid , #customizeidQr")
              .text("Next")
              .css({ opacity: "1", "pointer-events": "auto" });
          }
        },
        error: function (err) {
          console.error("Error fetching product variation:", err);
        },
      });
    }
  }

  // Handle product image selection
  productImages.forEach(function (imageContainer) {
    imageContainer.addEventListener("click", function () {
      // Update selected image
      imageSelected = this.querySelector("img").getAttribute("src");
      document
        .querySelector(".Product-image img")
        .setAttribute("src", imageSelected);

      productImages.forEach(function (img) {
        return img.classList.remove("product-colors-image-border");
      });
      this.classList.add("product-colors-image-border");

      // checkIfAllSelected();
    });
  });

  const firstColumn = document.querySelector(".product-container-col");
  const secondColumn = document.querySelector(".customizeid-col");
  const containerRow = document.querySelector(".product-container-row");

  const Imagewrappercontainer = document.querySelector(
    ".images-wrapper-container"
  );

  Imagewrappercontainer.addEventListener("scroll", function () {
    if (window.innerWidth < 767) {
      if (Imagewrappercontainer.scrollLeft > 0) {
        Imagewrappercontainer.style.marginLeft = "0px"; // Remove left margin when scrolling
      } else {
        Imagewrappercontainer.style.marginLeft = "16px"; // Restore margin when scrolled back
      }
    }
  });

  let isScrollingTogether = false; // Track whether the columns are scrolling together

  const handleScroll = function () {
    const isDesktop = window.innerWidth > 1200; // Desktop breakpoint
    if (!isDesktop) return; // Exit if not on desktop

    const firstColumnRect = firstColumn.getBoundingClientRect();
    const secondColumnRect = secondColumn.getBoundingClientRect();
    const containerRect = containerRow.getBoundingClientRect();

    // Check if the second column has reached the bottom of the first column
    if (secondColumnRect.bottom <= firstColumnRect.bottom) {
      if (isScrollingTogether) {
        isScrollingTogether = true; // Update state to scrolling together
        firstColumn.style.position = "relative";
        firstColumn.style.top =
          "" + secondColumnRect.top - containerRect.top + "px";
      }
    } else if (secondColumnRect.top <= containerRect.top) {
      // Reset sticky behavior when scrolling back up
      if (!isScrollingTogether) {
        isScrollingTogether = false; // Update state to not scrolling together
        firstColumn.style.position = "sticky";
        firstColumn.style.top = "88px";
      }
    }
  };

  window.addEventListener("scroll", handleScroll);

  // Re-check window size on resize to enable/disable the function dynamically
  window.addEventListener("resize", function () {
    const isDesktop = window.innerWidth >= 1200; // Desktop breakpoint
    if (!isDesktop) {
      // Reset styles if switching to mobile
      firstColumn.style.position = "";
      firstColumn.style.top = "";
    }
  });

  // Helper function to smoothly scroll to an element
  function smoothScrollToElement(element, offset = 0) {
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({
      top: elementPosition - 300,
      behavior: "smooth",
    });
  }

  // Desktop: Trigger scroll when validation is complete
  function handleDesktopScroll() {
    const ctaElement = document.querySelector("#customizeid"); // Replace with your CTA button selector
    const desktopOffset = 100; // Adjust offset to ensure button is above the fold
    smoothScrollToElement(ctaElement, desktopOffset);
  }

  const customizeid = document.getElementById("customizeid");
  const pdpEditbutton = document.getElementById("pdpEditbutton");
  const customizeidQr = document.getElementById("customizeidQr");

  pdpEditbutton?.addEventListener("click", function () {
    document.querySelector(".custom-engrave-container").classList.add("d-none");
    document.querySelector(".engravepdplikeheader").classList.remove("d-none");
    document
      .querySelector(".engrave-plp-card-container")
      .classList.remove("d-none");
    document
      .querySelector(".productOnlyContainerPDP")
      .classList.remove("d-none");
    // $(".engraveBar").addClass("d-none");
    $(".engraveBar").removeClass("Wizard-account");
    $(".Wizard-account-bar, .Wizard-engrave-bar").css(
      "background-color",
      "#828991"
    );
    $(".Wizard-engrave").removeClass("progress-active");
    $(".Wizard-account").removeClass("progress-deactive");
    $(".Wizard-account").addClass("progress-active");
    $(".Wizard-checked-circle-account").removeClass("Wizard-account-circle");
  });

  customizeid.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Enables smooth scrolling
    });
    if (checkIfAllSelected()) {
      document
        .querySelector(".custom-engrave-container")
        .classList.remove("d-none");
      document.querySelector(".engravepdplikeheader").classList.add("d-none");
      document
        .querySelector(".engrave-plp-card-container")
        .classList.add("d-none");
      document
        .querySelector(".productOnlyContainerPDP")
        .classList.add("d-none");
      $(".engraveBar").removeClass("d-none");
      $(".Wizard-account-bar, .Wizard-engrave-bar").css(
        "background-color",
        "#0f7ef8"
      );
      $(".Wizard-engrave").addClass("progress-active");
      $(".Wizard-account").removeClass("progress-active");
      $(".Wizard-account").addClass("progress-deactive");
      $(".Wizard-checked-circle-account").addClass("Wizard-account-circle");
    } else {
      if (colorSelected == null) {
        $("#colorHeader").addClass("errorState");
        $(".customize-color-container").each(function () {
          $(this).addClass("color-error-state");
        });
      }
      if (sizeSelected == null) {
        $("#sizeHeader").addClass("errorState");
        $(".customizeid-sizechart .customize-size-container").each(function () {
          $(this).addClass("size-error-state");
        });
      }
    }
  });

  customizeidQr?.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Enables smooth scrolling
    });
    if (checkIfAllSelected()) {
      // Check if all options are selected
      var pid = null;
      $(".modern-product-detail").each(function () {
        pid = $(this).find(".product-id").text();
      });
      var idType = $("#idType").text().trim();
      var url = $(".move-to-plan").val();
      var urlParams = new URLSearchParams(window.location.search);
      var editPid = urlParams.get("editPid");
      $.ajax({
        url: url,
        type: "POST",
        data: {
          pid: pid,
          idType: idType,
          editPid: editPid,
        },
        success: function (response) {
          if (response.redirectUrl) {
            window.location.href = response.redirectUrl;
          }
        },
        error: function (xhr, status, error) {
          console.log("Error:", error);
        },
      });
    } else {
      if (colorSelected == null) {
        $("#colorHeader").addClass("errorState");
        $(".customize-color-container").each(function () {
          $(this).addClass("color-error-state");
        });
      }
      if (sizeSelected == null) {
        $("#sizeHeader").addClass("errorState");
        $(".customizeid-sizechart .customize-size-container").each(function () {
          $(this).addClass("size-error-state");
        });
      }
    }
  });

  document.querySelectorAll(".engraveInput").forEach(function (input) {
    const counter = input.nextElementSibling; // Selects the adjacent counter div
    input.addEventListener("input", function () {
      const previewId = "p" + input.id;
      const previewElement = document.getElementById(previewId);
      if (previewElement) {
        previewElement.textContent = input.value; // Update preview with input value
      }
      const maxLength = input.getAttribute("maxlength");
      const remaining = maxLength - input.value.length;
      counter.textContent = remaining; // Updates the counter text
    });
  });

  // Handle Read More functionality
  document.querySelectorAll(".read-more").forEach(function (button) {
    button.addEventListener("click", function (event) {
      toggleReadMore(this, event);
    });
  });

  function toggleReadMore(button, event) {
    event.stopPropagation(); // Prevent accordion collapse
    const body = button.previousElementSibling;
    const isExpanded = body.classList.toggle("expanded");
    button.textContent = isExpanded ? "Read Less" : "Read More";
  }

  function updateLinkTarget() {
    let link = document.querySelector(".plp-Accordian-body a"); // Select the link
    if (window.innerWidth <= 768) {
      link.setAttribute("target", "_self");
    } else {
      link.setAttribute("target", "_blank");
    }
  }

  // Run function on page load
  updateLinkTarget();

  // Listen for screen resizing
  window.addEventListener("resize", updateLinkTarget);

  $(document).ready(function () {
    const accordions = $(".accordion-item");

    accordions.each(function () {
      const accordion = $(this);
      const collapseElement = accordion.find(".collapse");

      collapseElement.on("show.bs.collapse", function () {
        // accordions.removeClass("active");
        accordion.addClass("active");
      });

      collapseElement.on("hidden.bs.collapse", function () {
        accordion.removeClass("active");
      });
    });
    // Prevent accordion from closing when clicking a link inside it
    $(".accordion-item a").on("click", function (event) {
      event.stopPropagation(); // Stops Bootstrap from handling this click
    });
  });
});
